import { FC, PropsWithChildren } from 'react';

export const AccordionWrapper: FC<PropsWithChildren> = ({ children }) => {
  return <div>{children}</div>;
};
